import { render, staticRenderFns } from "./ResendConfirmCodePage.vue?vue&type=template&id=77e903b6&scoped=true"
import script from "./ResendConfirmCodePage.vue?vue&type=script&lang=ts"
export * from "./ResendConfirmCodePage.vue?vue&type=script&lang=ts"
import style0 from "./ResendConfirmCodePage.vue?vue&type=style&index=0&id=77e903b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e903b6",
  null
  
)

export default component.exports